import React from 'react';

const Privacy: React.FC = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1>Privacy Policy</h1>
        <p style={styles.updated}>Last Updated: February 15, 2026</p>

        <section style={styles.section}>
          <h2>1. Introduction</h2>
          <p>
            L Benoit Enterprises LLC DBA QuoteBid ("we," "us," or "our") respects your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your 
            information when you use our website and services at www.quotebid.io.
          </p>
        </section>

        <section style={styles.section}>
          <h2>2. Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect the following information when you register or use our Service:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Business name and address (for business accounts)</li>
            <li>Payment information (processed securely by Stripe)</li>
          </ul>
          
          <h3>Usage Information</h3>
          <p>We automatically collect certain information when you use our Service:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Pages visited</li>
            <li>Time and date of visits</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our Service</li>
            <li>Process transactions and send related information</li>
            <li>Send you notifications about quotes and account activity</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Improve our Service and develop new features</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

         <section style={styles.section}>
          <h2>4. SMS/Text Messaging</h2>
          <p>
            By providing your phone number during account registration at www.quotebid.io/register
            and checking the SMS consent checkbox, you consent to receive transactional SMS
            notifications from QuoteBid about your account activity, including new quote requests,
            quote submissions, and quote acceptances. Message frequency varies based on your
            marketplace activity. Message and data rates may apply.
          </p>
          <p>
            To opt out of SMS notifications at any time, reply STOP to any message. For help,
            reply HELP or contact support@quotebid.io. Opting out of SMS notifications will not
            affect your ability to use the QuoteBid platform.
          </p>
          <p>
            No mobile information collected as part of the SMS opt-in process will be shared
            with third parties or affiliates for marketing or promotional purposes. Mobile
            information may only be shared with service providers that help us deliver SMS
            messages (such as Twilio), as required by law, or with your explicit consent.
          </p>
        </section>

        <section style={styles.section}>
          <h2>5. Information Sharing</h2>
          <p>We may share your information with:</p>
          <ul>
            <li><strong>Other Users:</strong> Customers and businesses can see relevant information 
            to facilitate transactions (e.g., business names, quote details)</li>
            <li><strong>Service Providers:</strong> Third parties that help us operate our Service 
            (e.g., Stripe for payments, Twilio for SMS, Resend for email)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
          </ul>
          <p>We do not sell your personal information to third parties.</p>
        </section>

        <section style={styles.section}>
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your 
            personal information. However, no method of transmission over the Internet is 
            100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section style={styles.section}>
          <h2>7. Data Retention</h2>
          <p>
            We retain your personal information for as long as your account is active or as 
            needed to provide you services. You may request deletion of your account and 
            associated data by contacting us.
          </p>
        </section>

        <section style={styles.section}>
          <h2>8. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your account and data</li>
            <li>Opt out of marketing communications</li>
          </ul>
          <p>To exercise these rights, contact us at support@quotebid.io.</p>
        </section>

        <section style={styles.section}>
          <h2>9. Children's Privacy</h2>
          <p>
            Our Service is not intended for children under 18 years of age. We do not knowingly 
            collect personal information from children under 18.
          </p>
        </section>

        <section style={styles.section}>
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any 
            changes by posting the new Privacy Policy on this page and updating the "Last Updated" 
            date.
          </p>
        </section>

        <section style={styles.section}>
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at:<br />
            <strong>Email:</strong> support@quotebid.io<br />
            <strong>Address:</strong> 33310 Beverly Dr, Denham Springs, LA 70706
          </p>
        </section>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: '40px 20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  content: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  updated: {
    color: '#7f8c8d',
    fontStyle: 'italic',
    marginBottom: '30px',
  },
  section: {
    marginBottom: '30px',
  },
};

export default Privacy;